export enum ETimes {
	DATE = 'date',
	DAY = 'day',
	WEEK = 'week',
	MONTH = 'month',
}
